// Interface commune pour tous les providers de cartes
export interface ParkingSpot {
  place_id: string
  name: string
  address: string
  latitude: number
  longitude: number
  rating?: number
  price_level?: number
  opening_hours?: {
    open_now?: boolean
    weekday_text?: string[]
  }
  photos?: string[]
  distance?: number
}

export interface UserLocation {
  latitude: number
  longitude: number
  method?: string
}

export type GeolocationFailureCode =
  | 'PERMISSION_DENIED'
  | 'POSITION_UNAVAILABLE'
  | 'TIMEOUT'
  | 'UNSUPPORTED'
  | 'INSECURE_CONTEXT'
  | 'UNKNOWN'

export class GeolocationError extends Error {
  code: GeolocationFailureCode

  constructor(code: GeolocationFailureCode, message: string) {
    super(message)
    this.name = 'GeolocationError'
    this.code = code
  }
}

export interface MapBounds {
  center: UserLocation
  radius: number
}

export interface MapMarker {
  id: string
  position: UserLocation
  title: string
  isUser?: boolean
  onClick?: () => void
}

export enum MapProvider {
  GOOGLE = 'google',
  OPENSTREETMAP = 'openstreetmap'
}

export interface IMapService {
  // Initialisation
  loadMap(): Promise<void>
  initializeMap(element: HTMLElement, center: UserLocation): Promise<any>
  
  // Géolocalisation
  getCurrentLocation(): Promise<UserLocation & { method?: string }>
  requestLocationPermission(): Promise<boolean>
  
  // Gestion de la carte
  getMapBounds(map: any): MapBounds
  setMapCenter(map: any, location: UserLocation): void
  setMapZoom(map: any, zoom: number): void
  
  // Marqueurs
  addMarker(map: any, position: UserLocation, title: string, isUser?: boolean, variant?: 'default' | 'parked' | 'selected'): any
  removeMarker(marker: any): void
  clearMarkers(markers: any[]): void
  
  // Recherche de parkings
  searchNearbyParkings(location: UserLocation, radius?: number): Promise<ParkingSpot[]>
  searchParkingsInBounds(map: any, userLocation?: UserLocation): Promise<ParkingSpot[]>
  
  // Utilitaires
  calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number
  openDirections(destination: ParkingSpot): void
  
  // Nettoyage
  cleanup(): void
}

export interface MapConfig {
  provider: MapProvider
  googleApiKey?: string
  mapboxToken?: string
  defaultLocation: UserLocation
}
